import dayjs from "dayjs";

/**
 * Upper case first char
 * @param {String} string
 */
export function convertDateTime(timestamp, format = "ss:mm:HH DD/MM/YYYY") {
  if (!timestamp) {
    return "";
  }
  if (typeof timestamp === "number") {
    return dayjs(timestamp * 1000).format(format);
  }
  return dayjs(timestamp).format(format);
}

export function numberWithDelimiter(number, delimiter = ".") {
  return Math.round(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
}

export function getTagValue(item, data) {
  if (item.options && item.options.length > 0) {
    const option = item.options.find(
      (o) => data && (o.value || o.key) === data[item.key]
    );
    return option?.label || option?.name;
  }
  return data ? data[item.key] || item.key : item.key;
}

export function getContractName(id, contracts) {
  return contracts.find((s) => s.id === id)?.name || '';
}

export function getStepName(id, steps) {
  return steps.find((s) => s.id === id)?.name || '';
}

export function getStepsName(contractId, steps) {
  return steps.filter((s) => s.contract_id === contractId).map((s) => s.name).join(', ');
}

export function getFieldsName(keys, fields) {
  return fields.filter((f) => keys.includes(f.key)).map((f) => f.name).join(', ');
}

export function getStatusName(key, statuses) {
  const status = statuses.find((s) => s.value == key && !!s.name);
  return status?.name || key;
}
